import { createI18n } from 'vue-i18n';
import messages from '@/i18n';

export type MessageLanguages = keyof typeof messages;
export type MessageSchema = (typeof messages)['de'];

// Get language from URL path
function getLangFromUrl(): MessageLanguages {
  const path = window.location.pathname;
  const match = path.match(/^\/(en|de)/);
  return (match?.[1] as MessageLanguages) || 'de';
}

export const i18nInstance = createI18n<[MessageSchema], MessageLanguages, false>({
  locale: getLangFromUrl(),
  legacy: false,
  messages,
});

export default i18nInstance;
